// Pure attempt-scoping predicate shared by the poll and Pusher paths of
// useVgs3DSCompletion. Presence-guarded on BOTH sides: when either the
// active attempt key or the result's key is missing (backend not yet
// deployed, old event shape), the result is honored — exactly today's
// unscoped behavior.
export function belongsToActiveAttempt(
  activeMerchantTxId: string | undefined,
  resultMerchantTxId: string | undefined,
): boolean {
  if (!activeMerchantTxId || !resultMerchantTxId) return true;
  return resultMerchantTxId === activeMerchantTxId;
}
